import { render, staticRenderFns } from "./ModalTermOfUse.vue?vue&type=template&id=9f37f8ca&"
import script from "./ModalTermOfUse.vue?vue&type=script&lang=js&"
export * from "./ModalTermOfUse.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9f37f8ca')) {
      api.createRecord('9f37f8ca', component.options)
    } else {
      api.reload('9f37f8ca', component.options)
    }
    module.hot.accept("./ModalTermOfUse.vue?vue&type=template&id=9f37f8ca&", function () {
      api.rerender('9f37f8ca', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Terms/Modal/ModalTermOfUse.vue"
export default component.exports